import { z } from 'zod';

import type { DashboardLogadoTagsParams } from '@/features/performance-dashboard/schemas/dashboard-logado-params';
import { performanceDashboardBaseParamsSchema } from '@/features/performance-dashboard/schemas/dashboard-resultado-params';
import {
  tagsAnalysisResponseSchema,
  type TagsAnalysisResponse,
} from '@/features/performance-dashboard/schemas/tagsAnalysis';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export const getTagsAnalysisParamsSchema = performanceDashboardBaseParamsSchema.extend({
  eixoId: z.number().int().optional(),
  generoId: z.number().int().optional(),
});

export type GetTagsAnalysisParams = z.infer<typeof getTagsAnalysisParamsSchema>;

export const getTagsAnalysis = httpGetAdapter<TagsAnalysisResponse, GetTagsAnalysisParams>({
  url: '/v3/dashboard/resultado/analise-apontamentos',
  schema: tagsAnalysisResponseSchema,
  mapParams: (params) => params,
});

export type GetTagsAnalysisByTaskParams = { idTask: number; eixoId?: number; generoId?: number };

export const getTagsAnalysisByTask = httpGetAdapter<TagsAnalysisResponse, GetTagsAnalysisByTaskParams>({
  url: (params) => `/v3/dashboard/resultado/tarefa/${params.idTask}/analise-apontamentos`,
  schema: tagsAnalysisResponseSchema,
  mapParams: ({ eixoId, generoId }) => ({ eixoId, generoId }),
});

export type GetTagsAnalysisLogadoParams = DashboardLogadoTagsParams;

export const getTagsAnalysisLogado = httpGetAdapter<TagsAnalysisResponse, GetTagsAnalysisLogadoParams>({
  url: '/v3/dashboard/resultado/analise-apontamentos/logado',
  schema: tagsAnalysisResponseSchema,
  mapParams: (params) => ({
    anoLetivo: params.anoLetivo,
    categoriaId: params.categoriaId,
    nomModelo: params.nomModelo,
    eixoId: params.eixoId,
    generoId: params.generoId,
  }),
});

export type GetAnnotationsAnalysisParams = GetTagsAnalysisParams;
export type GetAnnotationsAnalysisByTarefaParams = GetTagsAnalysisByTaskParams;
export const getAnnotationsAnalysis = getTagsAnalysis;
export const getAnnotationsAnalysisByTarefa = getTagsAnalysisByTask;
